module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrap",
    class: [_vm.infoOutsideClass]
  }, [_c('div', {
    staticClass: "progress",
    class: [_vm.stripedClass, _vm.animatedClass, _vm.sizeClass]
  }, [_c('div', {
    staticClass: "progress-bar",
    class: [_vm.typeClass, _vm.sizeClass],
    style: ({
      width: _vm.percent + '%'
    })
  }, [(_vm.showinfo) ? _c('span', {
    staticClass: "progress-info"
  }, [_vm._v(_vm._s(_vm.info))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb8fe002!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progressbar/ProgressBar.vue
// module id = 359
// module chunks = 0